import {extendObservable, decorate, action} from 'mobx';
import request from 'superagent';
import moment from 'moment';
import {getCategories} from 'cms/faqs/Main/helperStore';
import {getHeadingTitle, getBreadcrump, tranformItem, replaceCmsUrl} from 'cms/helpers/common';
import {formatDateShort} from 'lib/helpers/globalize-helper';
import {transformData} from 'cms/faqs/Article/helper';

class ArticleStore {
  constructor(cms, translations) {
    const {id, h1, breadcrump, title, content, modified_gmt, sidebar, retrieveType, retrieveUrl} = cms;

    extendObservable(this, {
      loading: Boolean(retrieveUrl),
      errorOccured: false,
      remoteContent: {}
    });

    Object.assign(this, {
      title: getHeadingTitle(h1, title),
      content: content.rendered,
      modified: formatDateShort(moment(modified_gmt)),
      breadcrump: getBreadcrump(breadcrump),
      categories: getCategories(sidebar)
        .map((category) => ({
          ...category,
          subCategories: tranformItem(['ID', 'post_title', 'permanlink', 'post_parent'])(sidebar
            .filter(({post_parent}) => category.ID === post_parent))
            .map((item) => ({
              ...item,
              selected: item.ID === id,
              categorySelected: item.post_parent === category.ID
            }))
            .sort(({post_title: postTitleA}, {post_title: postTitleB}) =>
              (postTitleA).localeCompare(postTitleB))
        })),
      translations
    });

    if (retrieveUrl) {
      this.getRemoteContent(retrieveType, retrieveUrl);
    }
  }

  getRemoteContent = async (retrieveType, retrieveUrl) => {
    try {
      const {body} = await request.get(retrieveUrl);
      if (body.template === 'Ferry Price') {
        window.location.replace(replaceCmsUrl(body.link));
      } else if (body.data?.status === '301') {
        window.location.replace(body.data.url);
      } else {
        this.remoteContent = {
          retrieveType,
          data: transformData(retrieveType, body)
        };
      }
      this.loading = false;
    } catch {
      this.errorOccured = true;
      this.loading = false;
    }
  };
}

decorate(ArticleStore, {
  getRemoteContent: action
});

export default ArticleStore;
